<div class="container">

    <div class="row">
    
      <div class="col-md-12">
        <div class="main-card mb-3 card">
          <div class="card-header font-weight-B fs-1r"> Add Package</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2" ></div>
              <div class="col-md-4">
                <label for="">Sender Name : </label>
                <input type="text" [(ngModel)]="senderName" class="form-control" placeholder="Sender name">
              </div>
              <div class="col-md-4">
                <label for="">Receiver Name : </label>
                <input type="text" [(ngModel)]="receiverName" class="form-control" placeholder="Receiver name">
              </div>
              <div class="col-md-2" ></div>
            </div>

            <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                  <label for="">Sender Mobile No. : </label>
                  <input type="text" [(ngModel)]="senderMobile" maxlength="10" class="form-control" placeholder="Sender mobile no.">
                </div>
                <div class="col-md-4">
                  <label for="">Receiver Mobile No. : </label>
                  <input type="text" [(ngModel)]="receiverMobile"  maxlength="10"  class="form-control" placeholder="Receiver mobile no.">
                </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                  <label for="">Sender Email : </label>
                  <input type="email" [(ngModel)]="senderEmail" class="form-control" placeholder="Sender email">
                </div>
                <div class="col-md-4">
                  <label for="">Receiver Email : </label>
                  <input type="email"  [(ngModel)]="receiverEmail" class="form-control" placeholder="Receiver email">
                </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                  <label for="">Sender Address : </label>
                  <input type="text" (onAddressChange)="getSenderAddress($event)"  ngx-google-places-autocomplete   placeholder="Sender address" class="form-control">
                </div>
                <div class="col-md-4">
                  <label for="">Receiver Address : </label>
                  <input type="text" (onAddressChange)="getReceiverAddress($event)" ngx-google-places-autocomplete   placeholder="Receiver address" class="form-control">
                </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row" *ngIf="stopsBtn">
                <div class="col-md-2" ></div>
                  <div class="col-md-8">
                    <div class="d-grid gap-2">
                      <button (click)="openStopModal(addStop)" class="mb-2 mt-2 btn btn-primary btn-sm">   Add Stops <i class="fa fa-plus"></i></button>
                    </div>
                  </div>
                  <div class="col-md-2" ></div>
              </div>

              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                  <label for="">Sender Latitude : </label>
                  <input type="text" [(ngModel)]="senderLatitude"  class="form-control" [disabled]="true">
                </div>
                <div class="col-md-4">
                  <label for="">Receiver Latitude : </label>
                  <input type="text"  [(ngModel)]="receiverLatitude"  class="form-control" [disabled]="true">
                </div>
                <div class="col-md-2" ></div>
              </div>
              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                  <label for="">Sender Longtitude : </label>
                  <input type="text" [(ngModel)]="senderLongtitude"   class="form-control" [disabled]="true">
                </div>
                <div class="col-md-4">
                  <label for="">Receiver Longtitude : </label>
                  <input type="text" [(ngModel)]="receiverLongtitude"   class="form-control" [disabled]="true">
                </div>
                <div class="col-md-2" ></div>
              </div>
      
              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                  <label for="">Shipment Type : </label>
                  <select name="" id="" class="form-control"  [(ngModel)]="shipmentType">
                        <option value="">Select Good Type</option>
                        <option value="Test">Test</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="">Package Description : </label>
                  <input type="text"  [(ngModel)]="packageDesc"  class="form-control" placeholder="Package description">
                </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                    <label for="">No. of Packages : </label>
                    <input type="text"  [(ngModel)]="nosPackage"  class="form-control" placeholder="Numbers of packages">
                </div>
                <div class="col-md-4">
                  <label for="">Price Package Delivery : </label>
                  <input type="text" [(ngModel)]="packageDeliveryPrice"  class="form-control" placeholder="Price package delivery">
                </div>
                <div class="col-md-2" ></div>
              </div>
      
              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                    <label for="">Weight : </label>
                    <input type="text"   [(ngModel)]="packageWeight"  class="form-control" placeholder="Packages weight">
                </div>
                <div class="col-md-4">
                  <label for="">Distance : </label>
                  <input type="text" [(ngModel)]="distance" class="form-control" placeholder="Distance">
                </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-4">
                    <label for="">Driver Tip : </label>
                    <input type="text" [(ngModel)]="driverTip"  class="form-control" placeholder="Driver tip">
                </div>
                <div class="col-md-4">
                  <label for="">Special Instructions : </label>
                  <input type="text" [(ngModel)]="specialInstructions"  class="form-control" placeholder="Special instructions">

                </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-2">
                    <label for="">Send By SMS : </label> <br>
                    <label class="switch">
                        <input type="checkbox" (ngModelChange)="sendBySMS($event)" [(ngModel)]="isSendBySMS" >
                        <span class="slider round"></span>
                      </label>
                </div>
                <div class="col-md-2">
                    <label for="">Send By EMAIL : </label> <br>
                    <label class="switch">
                        <input type="checkbox" (ngModelChange)="sendByEMAIL($event)" [(ngModel)]="isSendByEMAIL">
                        <span class="slider round"></span>
                      </label>
                </div>
          
                <div class="col-md-4">
                    <label for="">Package Image : </label>
                   <input type="file"  (change)="getVehicleImage($event)"  placeholder="Package Image">
                   <div *ngIf="isValidImage == true" class="text-danger"> Please Select image file </div>
                   <div *ngIf="isImageUploaded == true" class="text-success"> Image Uploaded Successfully </div>
                </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row">
                <div class="col-md-2" ></div>
                <div class="col-md-2">
                    <label for="">Select Vehicle : </label> <br>
                  <select class="form-control" ngModel (ngModelChange)="getSelectedVehicle($event)">
                    <option value="">Select Vehicle</option>
                    <option *ngFor="let data of allVehiclesList" value="{{data | json}}" >{{data.vehicleName}}</option>
                  </select>
                </div>
                <div class="col-md-2" >
                  <label for="" *ngIf="labourStatus"> Labour Available : </label> <br>
                  <label class="switch" *ngIf="labourStatus">
                      <input type="checkbox" (ngModelChange)="checkLabour($event)"  [(ngModel)]="isLabourAvailable">
                      <span class="slider round"></span>
                    </label>
              </div>

                <div class="col-md-2">
                  <label for="">Coupon Code : </label> <br>
                  <input type="text" [(ngModel)]="couponCode"  class="form-control" placeholder="Coupon code">
                </div>
                <div class="col-md-2 text-end">
                  <label for=""> </label> <br>
                  <button (click)="applyCoupon()" [disabled]="couponCode == ''" class="btn-wide mb-2 me-2 btn btn-primary" >Apply Coupon
                  </button>
                 </div>
                <div class="col-md-2" ></div>
              </div>

              <div class="row" *ngIf="vehicleName">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <div class="table-responsive">
                    <table style="border: 1px solid black; border-collapse: collapse; width: 100%;">
                      <thead>
                        <th class="text-end">   Bill Details</th>
                      </thead>
                      <tr class="text-center">
                        <th style="border: 1px solid black; border-collapse: collapse;"> Fare Tip</th>
                        <td style="border: 1px solid black; border-collapse: collapse;"><i class="fa fa-inr" aria-hidden="true"></i> {{fareTip | number:'2.2-2'}}</td>
                      </tr>
                      <tr class="text-center">
                        <th style="border: 1px solid black; border-collapse: collapse;"> Labour Cost</th>
                        <td style="border: 1px solid black; border-collapse: collapse;"><i class="fa fa-inr" aria-hidden="true"></i>  {{labourCost | number:'2.2-2'}}</td>
                      </tr>
                      <tr class="text-center">
                        <th style="border: 1px solid black; border-collapse: collapse;"> Coupon Discount</th>
                        <td style="border: 1px solid black; border-collapse: collapse;"> <i class="fa fa-inr" aria-hidden="true"></i> <span *ngIf="couponCost != 0">-</span> {{couponCost | number:'2.2-2'}}</td>
                      </tr>
                      <tr class="text-center">
                        <th style="border: 1px solid black; border-collapse: collapse;"> Net Fare</th>
                        <td style="border: 1px solid black; border-collapse: collapse;"><i class="fa fa-inr" aria-hidden="true"></i> {{netFare | number:'2.2-2'}}</td>
                      </tr>
                      <tr class="text-center">
                        <th style="border: 1px solid black; border-collapse: collapse;"> Total Amount</th>
                        <td style="border: 1px solid black; border-collapse: collapse;"> <i class="fa fa-inr" aria-hidden="true"></i> {{totalAmount | number:'2.2-2'}}</td>
                      </tr>
                      <!-- </thead> -->
                    </table>
                  </div>
                </div>
                <div class="col-md-4"></div>
              </div>

             <div class="row text-center mt-3">
                    <div class="col-md-12">
                      <button (click)="addPackage()" class="btn-wide mb-2 me-2 btn btn-primary" [disabled]="senderName == '' || receiverName == '' || senderMobile == '' || receiverMobile == '' || senderEmail == '' || receiverEmail == '' || shipmentType == '' ||senderAddress == '' || receiverAddress == '' || nosPackage == '' || packageDeliveryPrice == '' || packageWeight == '' || distance == '' || vehicleName == ''">Add Package
                      </button>
                      <!-- <button (click)="addPackage()" class="btn-wide mb-2 me-2 btn btn-primary" >Add Package
                      </button> -->
              </div>
            </div> 
          </div>
        </div>
      </div>
    
          </div>
    
    
    
    
    
    
    </div>





    <div class="card-body">
      <ng-template #addStop let-c="close" let-d="dismiss">
        <div class="modal-header">
          <h4 class="modal-title"><i class="fa fa-plus"></i> Add Stops    </h4>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
          </button>
        </div>
        <div class="modal-body">
       
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-3">
              <label for="">Receiver Name : </label>
              <input type="text" [(ngModel)]="stopReceiverName" placeholder="Receiver name" class="form-control" [disabled]="disabledAllStopField">
            </div>
            <div class="col-md-3">
              <label for="">Receiver No. : </label>
              <input type="text" [(ngModel)]="stopReceiverNo" placeholder="+91 xxxxx" class="form-control" [disabled]="disabledAllStopField">
            </div>
            <div class="col-md-3">
              <label for="">Address : </label>
              <input type="text" (onAddressChange)="getStopageReceiverAddress($event)" [(ngModel)]="stopReceiverAddress" ngx-google-places-autocomplete  placeholder="Address" class="form-control" [disabled]="disabledAllStopField">
            </div>
            <div class="col-md-1">
              <label for=""> </label>
               <button (click)="addStopage()" class="btn btn-primary" [disabled]="stopReceiverName == '' || stopReceiverNo == '' || stopReceiverAddress == '' || disabledAllStopField == true">Add </button>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row" *ngIf="disabledAllStopField">
            <div class="col-md-12 text-center">
              <span class="text-danger">You have reached your maximum limit of stops</span>
            </div>
          </div>



          <div class="row mt-3" >
            <div class="col-md-1"></div>
            <div class="col-md-10">
          <div class="main-card mb-3 card">
            <div class="card-header text-center">
              Added Stops
            </div>
            <div class="table-responsive">
              <table class="align-middle mb-0 table table-borderless table-striped table-hover"  id="excel-table">
                <thead>
                <tr>
                  <th> Receiver Name</th>
                  <th>Receiver No.</th>
                  <th>Address</th>
                  <th>Latitude</th>
                  <th>Longtitude</th>
                  <th class="text-end">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let data of stopageArray" >
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.receiverName}}</div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.receiverPhoneNo}}</div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.address}}</div>
                          <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.latitude}}</div>
                          <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.longitude}}</div>
                          <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                        </div>
                      </div>
                    </div>
                  </td>

                 
                  <td class="text-center">
                      <a class="text-danger" (click)="removeStopage(data)"> <i class="fa fa-trash"></i></a>
                  </td>
                </tr>
               
                </tbody>
                
              </table>
              <div *ngIf="stopageArray?.length  == 0" class="text-center mt-5 mb-5" >
                <span class="text-danger">No Stops Added</span>
              </div>
            </div>
          </div>
        </div>
          <div class="col-md-1"></div>
        </div>
            
          
  
        </div>
      </ng-template>
    </div>